"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqData = [{
  question: "What labeling does Evermark make for electrical contractors?",
  answer: "Evermark Industrial Solutions makes engraved legend plates, panel nameplates, panel schedules, pushbutton plates, arc flash labels, and cable/wire ID tags for control panels and electrical equipment."
}, {
  question: "How fast can I get an order?",
  answer: "Evermark Industrial Solutions quotes a real lead time on every order with rush production available; standard and rush turnaround are confirmed on the quote — see {{verify: standard/rush lead time}}."
}, {
  question: "Can I upload a panel layout instead of typing out every legend?",
  answer: "Yes — Evermark Industrial Solutions engraves from a panel drawing or legend list (DXF, DWG, AI, PDF, SVG), and confirms the layout on a proof before production."
}, {
  question: "Can Evermark match my existing plates or a spec?",
  answer: "Yes — Evermark Industrial Solutions matches existing plate sizes, colors, and layouts, or builds to a project spec, confirmed on a proof."
}, {
  question: "Will the labels pass inspection?",
  answer: "Evermark Industrial Solutions produces marking designed to align with UL 508A, NEC 110.16, NFPA 70E, and ANSI Z535 when properly specified; whether an installation passes depends on the equipment, the data, and the authority having jurisdiction, which Evermark recommends confirming with the engineer of record or inspector. For arc flash labels specifically, Evermark produces the label from the data in your arc flash study and does not perform the study or determine the hazard values."
}];
export default function Faq() {
  return <section id="faq" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-3xl md:text-4xl font-default font-bold tracking-tight text-foreground">
            Electrical Contractor Labeling — Common Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i}>
              <AccordionTrigger className="text-left font-default text-lg font-semibold text-foreground hover:text-primary transition-colors">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-base text-muted-foreground leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        {}
      </div>
    </section>;
}